var Elevations;
(function (Elevations) {
    Elevations["UserIdentity"] = "USER_IDENTITY";
    Elevations["UserBackendCodeIdentity"] = "USER_BACKEND_CODE_IDENTITY";
    Elevations["Dynamic"] = "DYNAMIC";
})(Elevations || (Elevations = {}));
export { Elevations };
//# sourceMappingURL=Elevations.js.map